module.exports = __webpack_public_path__ + "static/blob-corner-954e0d577ea22962220e0ce21abc3420.png";